import React, { useEffect } from 'react';
import { connect, useDispatch } from "react-redux";

import ButtonFollow from './ButtonFollow';

import {
  setMBStore,
  setMBPathCustom,
  addMBType,
  removeMBType,
} from "./redux/actions/index";

function ConnectedMainWrapper({ api, isConnected, storePopup }) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (api && isConnected) {

      const setStateFollow = (id, type, isFollow) => {
        return () => {
          let data = {};
          const tl = type.toLowerCase();
          data[`${tl}_ids`] = [id];
          if (!isFollow) {
            api.post(`/my/beatport/`, data);
            dispatch(addMBType(id, tl));
          } else {
            api.delCustom(`/my/beatport/`, data);
            dispatch(removeMBType(id, tl));
          }
        }
      }
      const setButtonFollow = (id, type, isFollow) => <ButtonFollow isFollow={isFollow} onClick={setStateFollow(id, type, isFollow)} />

      api.getFromApi(`/my/beatport/`, false).then( res => {
        if (res.data && res.data.results) {
          const data = res.data.results;
          let path = `&order_by=-publish_date`;
          if (path.length > 0) {
            dispatch(setMBStore({
              artist: data.performer,
              label: data.label,
              setButtonFollow: setButtonFollow,
              setStateFollow: setStateFollow
            }));
            dispatch(setMBPathCustom(path));
          }
        }
      })
    } else if (!isConnected) {
      dispatch(setMBPathCustom(''));
      const setButtonFollow = () => <ButtonFollow isFollow={false} onClick={() => { storePopup.follow('.follow-button') }} />
      dispatch(setMBStore({
        artist: [],
        label: [],
        setButtonFollow: setButtonFollow,
        setStateFollow: () => {}
      }));
    }
  }, [isConnected, storePopup, api, dispatch])

  return null;
}

const MainWrapper = connect(
  state => ({
    api: state.api,
    isConnected: state.isConnected,
    storePopup: state.storePopup
  })
)(ConnectedMainWrapper);

export default MainWrapper;
